import { Component, OnInit } from '@angular/core';
import { RegulationsService } from '../../services/regulations-service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { Regulations } from '../../models/regulation';
import { FileVm } from '../../../../shared/Models/fileVm';
import { uploadService } from '../../../../shared/uploadService';
import { switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-add-regulation',
  templateUrl: './add-regulation.component.html',
  styleUrls: ['./add-regulation.component.scss'],
})
export class AddRegulationComponent implements OnInit {
  fileName:string[]=[]

  model = {} as Regulations;
  isEdit = false;
  attachements = new FormData();
  constructor(
    private route : Router,
    private diagRef: NbDialogRef<AddRegulationComponent>,
    private service: RegulationsService,
    private uploadService: uploadService,
    private toast: NbToastrService
  ) {}

  ngOnInit() {
      this.route.events.subscribe(()=>{
      this.diagRef.close('false');
     });
    if (this.isEdit) {
      this.uploadService.updateFiles({ files:[],previousAttachments: this.model.attachements});
    }
    if (!this.isEdit) {
      this.model.contentAR = '';
      this.model.contentEN = '';
      this.uploadService.updateFiles({ files:[],previousAttachments: []});
    }
  }

  save() {


    this.uploadService.uploadMultipleFiles()
    .pipe(
      switchMap((res) => {
        this.model.attachements = res;
        return this.service.post(this.model);
      })
    )

    .subscribe({
      next: (res) => {
          this.diagRef.close('true');
      this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
      },
      error: (err) => {
        this.diagRef.close('true');
        this.toast.danger('خطأ في الحفظ', '', { status: 'success', duration: 3000 });
    }
  })
    // let fileInput = document.getElementById('attachements') as any;
    // let hasAttachments = false;
    // this.attachements.forEach(() => {
    //   hasAttachments = true;
    // });


    // if (hasAttachments) {
    //   this.service.uploadMultipleFiles(this.attachements).subscribe((res) => {
    //     this.model.attachements = [];
    //     res.forEach((element,index) => {
    //       this.model.attachements.push({
    //         fileName: element,
    //         originalFileName: this.fileName[index],
    //       } as FileVm);
    //     });

    //     this.saveRegulation();
    //   });
    // } else {
    //   this.saveRegulation();
    // }



  }

  saveRegulation() {
    this.service.post(this.model).subscribe((res) => {
      this.diagRef.close('true');
      this.toast.show('تم الإضافة بنجاح', '', { status: 'success', duration: 3000 });
    });
  }
  close() {
    this.diagRef.close();
  }

  isFormValid() {
    return this.model.nameAR;
  }

  uploadFile(files: any) {
    this.fileName=[]
    for (let file of files) {
      this.attachements.append(file.name, file);
      this.fileName.push(file.name)
    }
  }

  updateRegulation() {

    this.uploadService.uploadMultipleFiles()
    .pipe(
      switchMap((res) => {
        this.model.attachements = res;
        return this.service.put(this.model.id, this.model)
      })
    )

    .subscribe({
      next: (res) => {
          this.diagRef.close('true');
      this.toast.show('تم التعديل بنجاح', '', { status: 'success', duration: 3000 });
      },
      error: (err) => {
        this.diagRef.close('true');
        this.toast.danger('خطأ في التعديل', '', { status: 'success', duration: 3000 });
    }
  })
  }
}
